export function getLoginUrl() {
  const isLocal =
    window.location.hostname === "local.google.apps-dotincorp.com" ||
    window.location.hostname === "localhost";

  const callbackUrl = isLocal
    ? "https://local.google.apps-dotincorp.com:3000/login-callback"
    : "https://stem.google.apps-dotincorp.com/login-callback";

  return `https://account.google.apps-dotincorp.com/login?cb=${callbackUrl}&s=S260129001&c=C251117001`;
}

export async function checkLogin(store) {
  try {
    const userRes = await fetch("/user-app/v2/users/me", {
      credentials: "include",
    });

    if (userRes.ok) {
      const data = await userRes.json();
      store.commit("SET_USER_NO", data.USER_NO);
      return true;
    }

    if (userRes.status === 401 || userRes.status === 412) {
      const refreshRes = await fetch(
        "/user-app/v2/auth/token/refresh",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            SITE_NO: "S260129001",
            COMP_NO: "C251117001",
          }),
        }
      );

      if (!refreshRes.ok) return false;

      const retryRes = await fetch("/user-app/v2/users/me", {
        credentials: "include",
      });

      if (!retryRes.ok) return false;

      const retryData = await retryRes.json();
      store.commit("SET_USER_NO", retryData.USER_NO);
      return true;
    }

    return false;
  } catch (e) {
    console.error("로그인 검증 실패:", e);
    return false;
  }
}
